import React from "react"
import { ChildSelector } from "../helpers/ChildSelector"
import WPImage, { DISPLAY_MODE } from "./_base/WPImage"

import * as threeImageCardsStyles from "../styles/ThreeImageCards.module.css"

export default function ThreeImageCards(props) {
  const { content } = props

  const cards = ChildSelector.select(
    content,
    "card",
    ChildSelector.SELECTOR_TYPE.ARRAY,
  ).map(card => ({
    holder: card,
    title: ChildSelector.select(
      card,
      "card-title",
      ChildSelector.SELECTOR_TYPE.TEXT,
    ),
    text: ChildSelector.select(
      card,
      "card-text",
      ChildSelector.SELECTOR_TYPE.TEXT,
    ),
  }))

  return (
    <>
      <div className={`row ${threeImageCardsStyles.externalWrapper}`}>
        <div className="container">
          <div
            className={`row row-cols-1 row-cols-md-3 g-4 ${threeImageCardsStyles.wrapper}`}
          >
            {cards.map((card, index) => (
              <div key={index} className="col">
                <div
                  className={`card h-100 ${threeImageCardsStyles.imageCard}`}
                >
                  <div className={`${threeImageCardsStyles.cardImgTop}`}>
                    <WPImage
                      holder={card.holder}
                      selector="card-image"
                      mode={DISPLAY_MODE.normal}
                      className="card-img-top"
                    />
                  </div>
                  <div className={`${threeImageCardsStyles.cardBody}`}>
                    {card.title && <h3 className="card-title">{card.title}</h3>}
                    {card.text && <div className="card-text">{card.text}</div>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}
